import axios from 'axios'

export const listpage = params => { return axios.get(`/program`, { params: params }) }
export const save = params => { return params.id ? axios.put(`/program`, params) : axios.post(`/program`, params) }
export const all = params => { return axios.get(`/program/all`, { params: params }) }
export const remove = params => { return axios.delete(`/program/${params.id}`, { params: params }) }
export const get = params => { return axios.get(`/program/` + params.id, { params: params }) }
export const certlist = params => { return axios.get(`/trainer/certification/list`, { params: params }) }
export const course = {
  listpage (params) { return axios.get(`/admin/program/${params.coachId}/courses/page`, { params: params }) },
  remove (params) { return axios.delete(`/program/courses`, { params: params }) }
}
export const member = {
  listpage (params) { return axios.get(`/program/${params.coachId}/memebers`, { params: params }) },
  remove (params) { return axios.delete(`/program/members`, { params: params }) }
}



// WEBPACK FOOTER //
// ./src/services/api/program/index.js